import { MenuItem, MenuItemProps } from "@mui/material";
import React from "react";

export interface IProps extends MenuItemProps {}
const FmMenuItem: React.FC<IProps> = (props) => {
    return <MenuItem {...props} className={props.className}></MenuItem>;
};

export default FmMenuItem;
